// Core imports
import * as React from 'react';

// Components imports
import Select from 'src/components/common/Select';
import SubcategoryModel from 'src/model/subcategory.model';

// Models imports Style and misc imports
import './MobileSubcategoriesSelect.scss';

export default class MobileSubcategoriesSelect extends React.Component<
  IMobileSubcategoriesSelectProps,
  any
> {
  /*
			setSelectOptions
	 */
  private setSelectOptions = () => {
    const selectOptions: any = [];
    this.props.subcategories.map(subcategory => {
      selectOptions.push({ value: subcategory.id, label: subcategory.name });
    });
    return selectOptions;
  };

  /*
			onSelectedSubcategory: Changes active subcategory
		 */
  private onSelectedSubcategory = (subcategoryId: any) => {
    this.props.changeSubcategory(subcategoryId.value);
  };

  /*
			getSelectedOption
		 */
  private getSelectedOption = (t: any) => {
    if (this.props.subcategories.length !== 0) {
      const selectedSubcategoryId = this.props.subcategories.findIndex(
        subcategory => {
          return (
            subcategory.id.toString() ===
            this.props.activeSubcategory.toString()
          );
        }
      );
      const selectedSubcategory = this.props.subcategories[
        selectedSubcategoryId
      ];
      if (selectedSubcategory) {
        return {
          value: selectedSubcategory.id,
          label: selectedSubcategory.name
        };
      } else {
        return { value: 0, label: '' };
      }
    } else {
      return { value: 0, label: '' };
    }
  };

  public render() {
    const { t } = this.props;

    return (
      <div className="mobile-subcategories-select">
        <Select
          height="40px"
          width="100%"
          options={this.setSelectOptions()}
          activeOption={this.getSelectedOption(t)}
          isLoading={this.props.isLoading}
          onSelected={this.onSelectedSubcategory}
        />
      </div>
    );
  }
}

interface IMobileSubcategoriesSelectProps {
  changeSubcategory(subcategoryId: number): any;
  subcategories: SubcategoryModel[];
  activeSubcategory: number;
  t: any;
  isLoading: boolean;
}
